const BUILD_DOMAIN = process.env.REACT_APP_BUILD_DOMAIN || "https://enlighten.enphaseenergy.com";

export const SIGNUP_URL = `${BUILD_DOMAIN}/manager/registration`;
export const FORGOT_PASSWORD_URL = `${BUILD_DOMAIN}/forgot_password`;
export const PRIVACY_URL = process.env.REACT_APP_PRIVACY_URL || "https://enphase.com/legal/privacy-policy";
export const TERMS_URL = process.env.REACT_APP_TERMS_URL || "https://enphase.com/legal/terms-service";
